import pro1 from '../assets/popcorn.jpeg'
import pro2 from '../assets/sugar.jpeg'
import pro3 from '../assets/cone1.jpeg'
import pro4 from '../assets/marthandamOrder.jpeg'
import pro5 from '../assets/spicialTea.jpeg'
import pro6 from '../assets/bowlScooping.jpg'
import pro7 from '../assets/10cup.jpeg'
import pro8 from '../assets/5cup.jpeg'
import pro9 from '../assets/miniCassata.jpeg'
import pro10 from '../assets/4rscup.jpeg'
import pro11 from '../assets/panipuri.jpeg'
import pro12 from '../assets/welcomeDrink.jpeg'
import pro13 from '../assets/water1.jpeg'
import pro14 from '../assets/miniSunday.jpeg'
import pro15 from '../assets/balloon.jpeg'



const productCardData = [
    {
        imgsrc: pro1,
        title: "Live Popcorn",
        text: "RS 5.00 / per 1 piece",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro2,
        title: "Live Cotton candy",
        text: "RS 4.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro3,
        title: "Live Cone Scooping",
        text: "RS 8.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro4,
        title: "Live Tea & Bajji stall",
        text: "RS 10.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro5,
        title: "Live Special Tea",
        text: "Unlimited RS 10,000/-",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    
    {
        imgsrc: pro11,
        title: "Live Panipuri",
        text: "Unlimited RS 10,000/-",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro12,
        title: "Live Welcome Drinks",
        text: "RS 5.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro15,
        title: "Live Printed balloon",
        text: "RS 4.75 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro6,
        title: "Live Bowl Scooping",
        text: "RS 10.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro7,
        title: "100ml cup ICE-CREAM",
        text: "RS 7.50 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro8,
        title: "50ml cup ICE-CREAM",
        text: "RS 4.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro9,
        title: "Mini Cassata",
        text: "RS 14.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro10,
        title: "40ml cup ICE-CREAM",
        text: "RS 3.75 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    },
    {
        imgsrc: pro14,
        title: "Mini Swirls",
        text: "RS 11.15 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    }
    ,
    {
        imgsrc: pro13,
        title: "300ml Water Bottle",
        text: "RS 4.00 / per 1 piece.",
        view: "https://youtube.com/shorts/9qHb0X3V67M?feature=share"
    }
    
]


export default productCardData;
